import { useAnalytics } from '@/services/analytics';
import { reaction } from 'mobx';
import { useEffect } from 'react';
import { useAdvancedEditorContext } from '../context/useAdvancedEditorContext';

export const useScenesPageActionsMixpanel = () => {
    const { store, scenesPageActionsFreeze } = useAdvancedEditorContext();
    const mixpanel = useAnalytics();

    useEffect(() => {
        const dispose = reaction(
            () => store.pages?.map(page => page.id) || [],
            (curr, prev) => {
                if (scenesPageActionsFreeze.current) {
                    return;
                }

                if (!curr.length || curr.length === prev.length) {
                    return;
                }

                if (curr.length > prev.length) {
                    const newPage = store.pages.find(page => !prev.includes(page.id));
                    // @ts-ignore
                    const isDuplicate = !!newPage.$treenode._initialSnapshot.custom;
                    const event = isDuplicate ? 'scene-duplicate' : 'scene-add';

                    mixpanel?.track(event, {
                        event: 'click',
                    });
                } else {
                    mixpanel?.track('scene-delete', {
                        event: 'click',
                    });
                }
            }
        );

        return () => {
            dispose();
        };
    }, []);
};
